import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { Box, Stack } from '@mui/system';

import FulfilmentHistory from '@/shared/types/fulfilment/history.type';

import HistoryStatus from '../types/historyStatus.enum';

type DetailsProps = {
  historyItem: FulfilmentHistory;
};

const Details: FC<DetailsProps> = ({ historyItem }) => {
  const { t } = useTranslation(['orders', 'common']);

  let tooltipColorByStatus: {
    backgroundColor: string;
    arrowColor: string;
    iconColor: string;
  };

  switch (historyItem.status as HistoryStatus) {
    case HistoryStatus.HELD:
      tooltipColorByStatus = {
        backgroundColor: red[50],
        arrowColor: red[50],
        iconColor: red[500],
      };
      break;
    default:
      tooltipColorByStatus = {
        backgroundColor: '',
        arrowColor: '',
        iconColor: '',
      };
      break;
  }

  return (
    <Box>
      <Stack direction='row' gap={1} alignItems='flex-start'>
        <Typography variant='body2' fontWeight='500'>
          {t('orders:fulfilmentOrder')} ({historyItem.status})
        </Typography>

        <Tooltip
          title={t(historyItem.provider_response)}
          placement='right'
          tabIndex={-1}
          arrow
          componentsProps={{
            arrow: {
              sx: {
                color: tooltipColorByStatus.arrowColor,
              },
            },
            tooltip: {
              sx: {
                backgroundColor: tooltipColorByStatus.backgroundColor,
                maxWidth: 350,
              },
            },
          }}
        >
          <InfoOutlinedIcon
            sx={{
              width: 16,
              height: 16,
              color: tooltipColorByStatus.iconColor,
            }}
          />
        </Tooltip>
      </Stack>
      <Typography variant='body2' color='text.secondary'>
        {historyItem.message}
      </Typography>
    </Box>
  );
};

export default Details;
